import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from "@angular/flex-layout";

import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns'
import {DatePickerModule, TimePickerModule} from "@progress/kendo-angular-dateinputs";
import { MaskedTextBoxModule } from "@progress/kendo-angular-inputs";
import { InputsModule } from '@progress/kendo-angular-inputs';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LabelModule } from '@progress/kendo-angular-label';

import { FwModule } from '../fw/fw.module';
import { UserApi } from '../fw/users/user-api';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';

import { AzureApiService } from './services/azure-api.service';
import { SettingsBaseService } from './settings/settings-base/settings-base.service';
import { SharedService } from './shared/shared.service';

import { AuthenticatedUserComponent } from './authenticated-user/authenticated-user.component';
import { HomeComponent } from './home/home.component';

import { SettingsCashregComponent } from './settings/settings-cashreg/settings-cashreg.component';
import { SettingsBaseComponent } from './settings/settings-base/settings-base.component';
import { FoundByComponent } from './settings/settings-base/found-by.component';
import { BtwComponent } from './settings/settings-base/btw.component';
import { MutationGroupComponent } from './settings/settings-base/mutationgroup.component';
import { TreatmentSalesgroupComponent } from './settings/settings-base/treatment-salesgroup.component';
import { TreatmentSubSalesgroupComponent } from './settings/settings-base/treatment-subsalesgroup.component';

import { ConfirmComponent } from './shared/confirm.component';
import { MessageComponent } from './shared/message.component';
import { ValidationMessageComponent } from './shared/validation-message.component';

import '@progress/kendo-angular-intl/locales/nl/all';
import '@progress/kendo-angular-intl/locales/nl/calendar';
import {ArticleSalesgroupComponent} from "./settings/settings-base/article-salesgroup.component";
import {ArticleSubSalesgroupComponent} from "./settings/settings-base/article-subsalesgroup.component";
import {CashregGroupComponent} from "./settings/settings-base/cashreggroup.component";
import {CashregSubgroupComponent} from "./settings/settings-base/cashregsubgroup.component";
import {DepartmentComponent} from "./settings/settings-base/department.component";
import {SupplierComponent} from "./settings/settings-base/supplier.component";
import {SharedDataService} from "./shared/shared-data.service";
import {SettingsCashregService} from "./settings/settings-cashreg/settings-cashreg.service";
import {SettingsEventActionService} from "./settings/settings-eventaction/settings-eventaction.service";
import {SettingsEventActionColorComponent} from "./settings/settings-eventaction/settings-eventaction-color.component";
import {EventActionComponent} from "./settings/settings-eventaction/eventaction.component";
import {SettingsEventActionPermComponent} from "./settings/settings-eventaction/settings-eventaction-perm.component";
import {ArticleComponent} from "./settings/settings-cashreg/article.component";
import {BarcodeComponent} from "./settings/settings-cashreg/barcode.component";
import {ArticleSupplierComponent} from "./settings/settings-cashreg/article-supplier.component";
import {TreatmentComponent} from "./settings/settings-cashreg/treatment.component";
import {TreatmentCombinationComponent} from "./settings/settings-cashreg/treatment-combination.component";
import {TreatmentCombinationSearchComponent} from "./settings/settings-cashreg/treatment-combination-search.component";
import {ArticleCombinationSearchComponent} from "./settings/settings-cashreg/article-combination-search.component";
import {DiscountComponent} from "./settings/settings-cashreg/discount.component";
import {QuantityDiscountComponent} from "./settings/settings-cashreg/quantity-discount.component";
import {GiftcertificateComponent} from "./settings/settings-cashreg/giftcertificate.component";
import {CurecreditTreatmentSearchComponent} from "./settings/settings-cashreg/curecredit-treatment-search.component";
import {CurecreditComponent} from "./settings/settings-cashreg/curecredit.component";
import {EmployeeService} from "./employees/employee-details/employee.service";
import {EmployeeListComponent} from "./employees/employee-details/employee-list.component";
import {SettingsSecurityService} from "./settings/settings-security/settings-security.service";
import {SettingsSecurityComponent} from "./settings/settings-security/settings-security.component";
import {SecurityAuthorisationComponent} from "./settings/settings-security/security-authorisation.component";
import {SettingsPlannerService} from "./settings/settings-planner/settings-planner.service";
import {SettingsPlannerComponent} from "./settings/settings-planner/settings-planner.component";
import {EmployeeComponent} from "./employees/employee-details/employee.component";
import {SharedMaskService} from "./shared/shared-masks.service";
import {StockOverviewService} from "./stock/stock-overview/stock-overview.service";
import {StockOverviewComponent} from "./stock/stock-overview/stock-overview.component";
import {StockInventoryComponent} from "./stock/stock-inventory/stock-inventory.component";
import {StockInventoryService} from "./stock/stock-inventory/stock-inventory.service";
import {InactivityComponent} from "./settings/settings-planner/inactivity.component";
import {ColorPickerModule} from "ngx-color-picker";
import {AppointmentlabelComponent} from "./settings/settings-planner/appointmentlabel.component";
import {AppointmentkindComponent} from "./settings/settings-planner/appointmentkind.component";
import {AppointmentkindCombinationComponent} from "./settings/settings-planner/appointmentkind-combination.component";
import {AppointmentkindSelectCombiComponent} from "./settings/settings-planner/appointmentkind-select-combi.component";
import {CashregWeekComponent} from "./administration/cashreg-week/cashreg-week.component";
import {CashregWeekService} from "./administration/cashreg-week/cashreg-week.service";
import {DepositService} from "./administration/deposit/deposit.service";
import {DepositComponent} from "./administration/deposit/deposit.component";
import {CustomerSearchComponent} from "./customers/customer-search/customer-search.component";
import {CustomerSearchService} from "./customers/customer-search/customer-search.service";
import {CustomerService} from "./customers/customer/customer.service";
import {CustomerComponent} from "./customers/customer/customer.component";
import {TreeViewModule} from "@progress/kendo-angular-treeview";
import {ManagementQuickviewService} from "./management/quickview/management-quickview.service";
import {ManagementQuickviewComponent} from "./management/quickview/management-quickview.component";
import {ChartModule} from "@progress/kendo-angular-charts";
import {CustomerOverviewService} from "./customers/customer-overview/customer-overview.service";
import {CustomerOverviewComponent} from "./customers/customer-overview/customer-overview.component";
import {TelerikReportingModule} from '@progress/telerik-angular-report-viewer';
import {ReportPreviewComponent} from "./shared/report-preview.component";
import {CashbookService} from "./administration/cashbook/cashbook.service";
import {CashbookComponent} from "./administration/cashbook/cashbook.component";
import {EmployeeSalaryComponent} from "./employees/employee-details/employee-salary.component";
import {Angular5Csv} from "angular5-csv/Angular5-csv";
import {TreatmentInfoService} from "./management/treatment-info/treatment-info.service";
import {TreatmentInfoComponent} from "./management/treatment-info/treatment-info.component";
import {ArticleInfoService} from "./management/article-info/article-info.service";
import {ArticleInfoComponent} from "./management/article-info/article-info.component";
import {ManagementCustomerInfoComponent} from "./management/customer-info/management-customer-info.component";
import {ManagementCustomerInfoService} from "./management/customer-info/management-customer-info.service";
import {BranchesListService} from "./branches/branches-list/branches-list.service";
import {BranchesListComponent} from "./branches/branches-list/branches-list.component";
import {ManagementSalesGoalService} from "./management/sales-goal/management-sales-goal.service";
import {ManagementSalesGoalComponent} from "./management/sales-goal/management-sales-goal.component";
import {CashregDayService} from "./administration/cashreg-day/cashreg-day.service";
import {CashregDayComponent} from "./administration/cashreg-day/cashreg-day.component";
import {ArticleDiscountComponent} from "./settings/settings-cashreg/article-discount.component";
import {ArticlePriceChangeComponent} from "./settings/settings-cashreg/article-price-change.component";
import {PriceChangeCorrectionComponent} from "./settings/settings-cashreg/price-change-correction.component";
import {PriceChangePercentageComponent} from "./settings/settings-cashreg/price-change-percentage.component";
import {TreatmentPriceChangeComponent} from "./settings/settings-cashreg/treatment-price-change.component";
import {ChooseImageComponent} from "./shared/choose-image.component";
import {FileHelpersModule} from "ngx-file-helpers";
import {ImageCropperModule} from "ngx-image-cropper";
import {ChangeUserPasswordComponent} from "./settings/settings-base/change-user-password.component";
import {EmployeeInfoService} from "./management/employee-info/employee-info.service";
import {EmployeeInfoComponent} from "./management/employee-info/employee-info.component";
import {MarketingInfoService} from "./marketing/marketing-info/marketing-info.service";
import {MarketingInfoComponent} from "./marketing/marketing-info/marketing-info.component";
import {ArcGaugeModule} from "@progress/kendo-angular-gauges";
import {SubscriptionTypeComponent} from "./settings/settings-cashreg/subscription-type.component";
import {SubscriptionTypeTreatmentComponent} from "./settings/settings-cashreg/subscription-type-treatment.component";
import {EmployeeHouroverviewService} from "./employees/employee-houroverview/employee-houroverview.service";
import {EmployeeHouroverviewComponent} from "./employees/employee-houroverview/employee-houroverview.component";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {GlobalErrorHandler} from "./GlobalErrorHandler";
import {EmployeeCreateComponent} from "./employees/employee-details/employee-create.component";
import {UsedGiftcertificatesComponent} from "./administration/used-giftcertificates/used-giftcertificates.component";
import {UsedGiftcertificateService} from "./administration/used-giftcertificates/used-giftcertificate.service";
import {DxReportViewerModule} from "devexpress-reporting-angular";
import {CustomerReportsAddComponent} from "./customers/customer-overview/dialogs/customer-reports-add.component";
import {DialogWrapperComponent} from "../fw/dialog-wrapper/dialog-wrapper.component";
import {DialogWrapperService} from "../fw/dialog-wrapper/dialog-wrapper.service";
import {AppointmentListComponent} from "./shared/appointment-list.component";
import {MailingAddComponent} from "./marketing/mailing/dialogs/mailing-add.component";
import {MailingComponent} from "./marketing/mailing/mailing.component";
import {MailingService} from "./marketing/mailing/mailing.service";
import {CustomerSatisfactionSurveyService} from "./marketing/customer-satisfaction-survey/customer-satisfaction-survey.service";
import {CustomerSatisfactionSurveyComponent} from "./marketing/customer-satisfaction-survey/customer-satisfaction-survey.component";

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        AuthenticatedUserComponent,
        SettingsCashregComponent,
        SettingsBaseComponent,
        FoundByComponent,
        BtwComponent,
        MutationGroupComponent,
        TreatmentSalesgroupComponent,
        TreatmentSubSalesgroupComponent,
        ArticleSalesgroupComponent,
        ArticleSubSalesgroupComponent,
        CashregGroupComponent,
        CashregSubgroupComponent,
        DepartmentComponent,
        SupplierComponent,
        SettingsEventActionColorComponent,
        SettingsEventActionPermComponent,
        EventActionComponent,
        ArticleComponent,
        BarcodeComponent,
        ArticleSupplierComponent,
        ArticleDiscountComponent,
        TreatmentComponent,
        TreatmentCombinationComponent,
        TreatmentCombinationSearchComponent,
        ArticleCombinationSearchComponent,
        DiscountComponent,
        QuantityDiscountComponent,
        GiftcertificateComponent,
        CurecreditTreatmentSearchComponent,
        CurecreditComponent,
        EmployeeListComponent,
        SettingsSecurityComponent,
        SecurityAuthorisationComponent,
        SettingsPlannerComponent,
        ConfirmComponent,
        MessageComponent,
        ValidationMessageComponent,
        EmployeeComponent,
        StockOverviewComponent,
        StockInventoryComponent,
        InactivityComponent,
        AppointmentlabelComponent,
        AppointmentkindComponent,
        AppointmentkindCombinationComponent,
        AppointmentkindSelectCombiComponent,
        CashregWeekComponent,
        DepositComponent,
        CustomerSearchComponent,
        CustomerComponent,
        ManagementQuickviewComponent,
        CustomerOverviewComponent,
        ReportPreviewComponent,
        CashbookComponent,
        EmployeeSalaryComponent,
        TreatmentInfoComponent,
        ArticleInfoComponent,
        ManagementCustomerInfoComponent,
        BranchesListComponent,
        ManagementSalesGoalComponent,
        CashregDayComponent,
        ArticlePriceChangeComponent,
        PriceChangeCorrectionComponent,
        PriceChangePercentageComponent,
        TreatmentPriceChangeComponent,
        ChooseImageComponent,
        ChangeUserPasswordComponent,
        EmployeeInfoComponent,
        MarketingInfoComponent,
        SubscriptionTypeComponent,
        SubscriptionTypeTreatmentComponent,
        EmployeeHouroverviewComponent,
        EmployeeCreateComponent,
        UsedGiftcertificatesComponent,
        CustomerReportsAddComponent,
        DialogWrapperComponent,
        AppointmentListComponent,
        MailingAddComponent,
        MailingComponent,
        CustomerSatisfactionSurveyComponent
    ],
    entryComponents: [
        FoundByComponent,
        BtwComponent,
        MutationGroupComponent,
        TreatmentSalesgroupComponent,
        TreatmentSubSalesgroupComponent,
        ArticleSalesgroupComponent,
        ArticleSubSalesgroupComponent,
        CashregGroupComponent,
        CashregSubgroupComponent,
        DepartmentComponent,
        SupplierComponent,
        EventActionComponent,
        ArticleComponent,
        BarcodeComponent,
        ArticleSupplierComponent,
        ArticleDiscountComponent,
        TreatmentComponent,
        TreatmentCombinationComponent,
        TreatmentCombinationSearchComponent,
        ArticleCombinationSearchComponent,
        DiscountComponent,
        QuantityDiscountComponent,
        GiftcertificateComponent,
        CurecreditTreatmentSearchComponent,
        CurecreditComponent,
        SecurityAuthorisationComponent,
        ConfirmComponent,
        MessageComponent,
        InactivityComponent,
        AppointmentlabelComponent,
        AppointmentkindComponent,
        AppointmentkindCombinationComponent,
        AppointmentkindSelectCombiComponent,
        ReportPreviewComponent,
        EmployeeSalaryComponent,
        ArticlePriceChangeComponent,
        PriceChangeCorrectionComponent,
        PriceChangePercentageComponent,
        TreatmentPriceChangeComponent,
        ChooseImageComponent,
        ChangeUserPasswordComponent,
        SubscriptionTypeComponent,
        SubscriptionTypeTreatmentComponent,
        EmployeeCreateComponent,
        CustomerReportsAddComponent,
        DialogWrapperComponent,
        AppointmentListComponent,
        MailingAddComponent
    ],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        GridModule,
        LayoutModule,
        FwModule,
        RouterModule.forRoot(appRoutes),
        DialogModule,
        FlexLayoutModule,
        DropDownsModule,
        DatePickerModule,
        MaskedTextBoxModule,
        TimePickerModule,
        InputsModule,
        IntlModule,
        LabelModule,
        ColorPickerModule,
        TreeViewModule,
        ChartModule,
        TelerikReportingModule,
        FileHelpersModule,
        ImageCropperModule,
        ArcGaugeModule,
        DxReportViewerModule
    ],
    providers: [
        DatePipe,
        AzureApiService,
        SettingsBaseService,
        SharedService,
        SharedMaskService,
        SharedDataService,
        SettingsCashregService,
        SettingsEventActionService,
        SettingsSecurityService,
        SettingsPlannerService,
        StockOverviewService,
        StockInventoryService,
        EmployeeService,
        CashregWeekService,
        DepositService,
        CustomerSearchService,
        CustomerService,
        ManagementQuickviewService,
        CustomerOverviewService,
        CashbookService,
        TreatmentInfoService,
        ArticleInfoService,
        ManagementCustomerInfoService,
        BranchesListService,
        ManagementSalesGoalService,
        EmployeeInfoService,
        CashregDayService,
        MarketingInfoService,
        EmployeeHouroverviewService,
        UsedGiftcertificateService,
        DialogWrapperService,
        MailingService,
        CustomerSatisfactionSurveyService,
        { provide: LOCALE_ID, useValue: 'nl-NL'},
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/app.module.ts